import { Dispatch } from '@reduxjs/toolkit';
import { resetDetailsState } from 'component/page/detail/store/details';
import { resetAvailabilityState } from 'component/page/detail/store/availabilityIndex';
import { resetCalendarState } from 'component/page/detail/store/calendar';

export const resetState = (dispatch: Dispatch) => {
    dispatch(resetDetailsState());
    dispatch(resetAvailabilityState());
    dispatch(resetCalendarState());
};
